var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { BaseModal } from "../../../../models/basics/basics.models";
var LookupHierarchyControlModal = /** @class */ (function (_super) {
    __extends(LookupHierarchyControlModal, _super);
    function LookupHierarchyControlModal(dialogService) {
        var _this = _super.call(this, dialogService) || this;
        _this.selectedLookupValues = [{}];
        return _this;
    }
    LookupHierarchyControlModal.prototype.activate = function (model) {
        this.model = model;
        if (model && model.itemSource) {
            var list = this.getIndex(0, model.itemSource);
            if (list) {
                for (var i = 0; i < list.length; i++) {
                    this.setSelectedItem(i, {
                        detail: {
                            value: list[i]
                        }
                    });
                }
            }
        }
    };
    LookupHierarchyControlModal.prototype.ok = function () {
        this.model.selectedItem = this.model.selectedItemInternal;
        this.model.selectedValue = this.model.getValue(this.model.selectedItem);
        this.hideModal();
    };
    LookupHierarchyControlModal.prototype.getIndex = function (index, items) {
        var e_1, _a;
        try {
            for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                var x = items_1_1.value;
                if (this.model.selectedItem && x.id === this.model.selectedItem.id) {
                    return [x];
                }
                else {
                    var list = this.getIndex(index + 1, x.children);
                    if (list) {
                        list.splice(0, 0, x);
                        return list;
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    };
    LookupHierarchyControlModal.prototype.setSelectedItem = function (index, event) {
        if (event) {
            if (this.selectedLookupValues.length - 1 >= index) {
                this.selectedLookupValues.splice(index, this.selectedLookupValues.length - index, event.detail.value);
            }
            else if (this.selectedLookupValues.length === index) {
                this.selectedLookupValues.push(event.detail.value);
            }
        }
    };
    LookupHierarchyControlModal = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService])
    ], LookupHierarchyControlModal);
    return LookupHierarchyControlModal;
}(BaseModal));
export { LookupHierarchyControlModal };
